import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import {CompanyEdit, CompanyReadOnly} from './CompanyForm';

export default function CompaniesPage({}: any) {
    return (
        <GenericCrudPage
            key='company-page'
            singularName='company'
            pageTitle='Companies'
            resource='companies'
            allowAdd={true}
            allowEdit={true}
            allowDelete={true}
            ReadOnlyComponent={CompanyReadOnly}
            EditFormComponent={CompanyEdit}
            tableColumns={[
                {
                    field: 'name',
                    headerName: 'Name',
                    width: 200,
                },
                {
                    field: 'title',
                    headerName: 'Title',
                    width: 200,
                },
                {
                    field: 'featured',
                    headerName: 'Sponser',
                    width: 200,
                },
            ]}
            newPayload={{
                title: '',
                name: '',
                about: '',
                featured: false,
                type: 'sponsor',
            }}
            validateFn={(data: any) => {
                return [true, []];
            }}
        />
    );
}
